export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensoren",
                        observations: "Waarnemingen",
                        modelling: "Modellering",
                        mapFeatures: "Kaart kenmerken",
                        output: "Exporteren & Rapporteren",
                        setUp: "Configuratie",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'milliseconde', plural: 'milliseconden' }, short: { singular: 'ms', plural: 'ms' } },
        seconds: { long: { singular: 'seconde', plural: 'seconden' }, short: { singular: 'sec.', plural: 'sec.' } },
        minutes: { long: { singular: 'minuut', plural: 'minuten' }, short: { singular: 'min.', plural: 'min.' } },
        hours: { long: { singular: 'uur', plural: 'uren' }, short: { singular: 'u.', plural: 'u.' } },
        days: { long: { singular: 'dag', plural: 'dagen' }, short: { singular: 'dg.', plural: 'dgn.' } },
        weeks: { long: { singular: 'week', plural: 'weken' }, short: { singular: 'wk.', plural: 'wkn.' } },
        months: { long: { singular: 'maand', plural: 'maanden' }, short: { singular: 'md.', plural: 'mdn.' } },
        quarters: { long: { singular: 'kwartaal', plural: 'kwartalen' }, short: { singular: 'kwrt.', plural: 'kwrtn.' } },
        years: { long: { singular: 'jaar', plural: 'jaren' }, short: { singular: 'jr.', plural: 'jrn.' } },
    },
    timezone: "Tijdzone",
    custom: 'aangepast',
    period: 'periode',
};
